// src/components/scenarios/VeraEducationalContent.js
import React, { useState } from 'react';
import './VeraEducationalContent.css';

function VeraEducationalContent() {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="educational-content vera-content">
      <h3>Voluntary Early Retirement Authority (VERA)</h3>
      
      <p>
        VERA, often called "early out" retirement, allows eligible federal employees to retire earlier than 
        normally permitted. VERA temporarily lowers the age and service requirements during periods of 
        substantial restructuring, reshaping, downsizing, or reorganization.
      </p>
      
      <h4>Eligibility Requirements:</h4>
      <ul>
        <li><strong>Age 50</strong> with at least <strong>20 years</strong> of creditable federal service, OR</li>
        <li><strong>Any age</strong> with at least <strong>25 years</strong> of creditable federal service</li>
      </ul>
      
      <div className="expandable-section">
        <button 
          className="expandable-header" 
          onClick={toggleExpanded}
          aria-expanded={expanded}
        >
          <span>Important VERA Information</span>
          <span className="toggle-icon">{expanded ? '−' : '+'}</span>
        </button>
        
        {expanded && (
          <div className="expandable-content">
            <h4>VERA Details:</h4>
            <ul>
              <li>Your agency must have VERA authority from OPM before offering early retirement</li>
              <li>You must be in a position covered by the agency's VERA plan</li>
              <li>There is <strong>no age reduction penalty</strong> under FERS for VERA retirees (unlike deferred retirement)</li>
              <li>FERS employees who retire under VERA before their Minimum Retirement Age (MRA) are not eligible for the FERS supplement until they reach their MRA</li>
              <li>You can include sick leave in your service credit calculation</li>
              <li>Special FERS employees (e.g., law enforcement, firefighters) also benefit from VERA</li>
              <li>You may be subject to a special reemployment salary offset if you return to federal service after VERA</li>
            </ul>
            
            <h4>FERS Annuity Calculation:</h4>
            <p>
              Your FERS basic annuity under VERA is calculated the same way as regular FERS retirement:
              <br />
              <strong>High-3 Salary × 1% × Years of Service</strong>
              <br />
              (The 1.1% multiplier for 62+ with 20+ years does not apply to VERA if you're under 62)
            </p>
            
            <h4>FERS Supplement:</h4>
            <p>
              If you retire under VERA before your Minimum Retirement Age (MRA, which is 55-57 depending on birth year), 
              you will become eligible for the FERS supplement when you reach your MRA, not at retirement. The supplement
              will continue until age 62, subject to the earnings test.
            </p>

            <div className="caution-box">
              <h4>Important Considerations:</h4>
              <ul>
                <li>VERA is only available when your agency has received specific authority from OPM</li>
                <li>Accepting VERA is voluntary - you are not required to retire early</li>
                <li>Consider the long-term financial impact of retiring earlier than planned</li>
                <li>Consult with your agency's HR office for personalized guidance</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VeraEducationalContent;
